import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function PaymentCancel() {
  const { t } = useLanguage();
  return (
    <div className="max-w-[900px] mx-auto px-6 py-24 text-center">
      <div className="text-stone-500 flex justify-center"><XCircle size={72} strokeWidth={1} /></div>
      <h1 className="font-serif text-5xl tracking-tighter mt-6">{t("Pagamento annullato.")}</h1>
      <p className="mt-4 text-stone-600">{t("Nessun addebito è stato effettuato. Puoi riprovare in qualsiasi momento dal dashboard.")}</p>
      <Link to="/dashboard" data-testid="cancel-dashboard-btn" className="mt-8 inline-block text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors">{t("Torna al dashboard")}</Link>
    </div>
  );
}
